import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectIsDemolished = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('demolished_in_moscow_programm')(jsonQuery),
);
